import { render, staticRenderFns } from "./InvestorReceivablePaymentsImgInfo.vue?vue&type=template&id=5e73aeef&scoped=true&"
import script from "./InvestorReceivablePaymentsImgInfo.vue?vue&type=script&lang=js&"
export * from "./InvestorReceivablePaymentsImgInfo.vue?vue&type=script&lang=js&"
import style0 from "./InvestorReceivablePaymentsImgInfo.vue?vue&type=style&index=0&id=5e73aeef&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e73aeef",
  null
  
)

export default component.exports